import User from '@/assets/icons/User.svg';
import { Link } from '@/components/Link';
import type { Urls } from '@/types';
import * as Styled from './AuthLinks.styled';

interface LinkData {
  isAuthenticated: boolean;
  urls: Urls;
}

interface AuthLinksProps extends LinkData {
  isPending: boolean;
}

const getLinkData = ({ isAuthenticated, urls }: LinkData) => {
  // SURGE MODE: Show unified link when basket count is hidden
  const hideBasketCount = (window as any).HIDE_BASKET_ITEM_COUNT === true;

  if (hideBasketCount) {
    // During surge, show single link that works for both auth states
    return [
      ...(urls.account ? [{ href: urls.account, text: 'Sign In / My Account' }] : []),
    ];
  }

  // Normal mode: show conditional links based on auth status
  if (isAuthenticated) {
    return [
      ...(urls.logout ? [{ href: urls.logout, text: 'Sign Out' }] : []),
      ...(urls.account ? [{ href: urls.account, text: 'My Account' }] : []),
    ];
  }

  return [
    ...(urls.login ? [{ href: urls.login, text: 'Sign In / Register' }] : []),
  ];
};

export const AuthLinks = ({
  isAuthenticated,
  isPending,
  urls,
}: AuthLinksProps) => {
  const authLinks = getLinkData({ isAuthenticated, urls });

  return (
    <Styled.LinksWrapper>
      <Styled.IconWrapper>
        <User />
      </Styled.IconWrapper>
      {isPending ? null : (
        <Styled.LinksList className="auth-links">
          {authLinks.map(link => (
            <li key={link.href}>
              <Link href={link.href}>{link.text}</Link>
            </li>
          ))}
        </Styled.LinksList>
      )}
    </Styled.LinksWrapper>
  );
};
